import { registerQuery } from 'data-fetching-client';
import * as ecosystemClient from '../clients/ecosystemClient';

function getCompatibility({
  offeringType
}) {
  return ecosystemClient.getCompatibility(offeringType);
}

export const GET_COMPATIBILITY = registerQuery({
  fieldName: 'compatibility',
  args: ['offeringType'],
  fetcher: getCompatibility
});